import { mapState } from '@/store/helpers';
import { checkSoldHousePreview } from '@/common/utils';
export default {
    i18next: { ns: 'md-house' },
    props: ['houses'],
    computed: {
        ...mapState({
            result: function(store) {
                return this.houses ? { listings: this.houses } : store.result;
            }
        })
    },
    watch: {
        result(result) {
            this.resultUpdated = true;
            checkSoldHousePreview(result);
        }
    },
    created() {
        checkSoldHousePreview(this.result);
    }
};
